module.exports = __webpack_public_path__ + "static/media/trade.81928e6a.svg";